import { Injectable } from '@angular/core';
import {  CanActivate } from '@angular/router';
import { GenericLoginService } from './generic-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BasicAuhtenticationGuard implements CanActivate { 

  constructor(private readonly genericLoginService: GenericLoginService) {}

  canActivate(): boolean {
    const user = localStorage.getItem('isBasicAuthSuccess');

    // Show login modal if not authenticated and not in production
    if (user !== 'true' && !environment.production) {
      this.genericLoginService.openGenericLoginModal();
    }
    
    return true;
  }
  
}
